import React, { useState } from 'react';
import colors from '../../colors';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ModalContainer from './ModalContainer';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { convertTimestampToTime } from '../../utils/helpers';
import dayjs from 'dayjs';

function TimeSelector({ isVisible, setIsVisible, dataCallback, defaultTime }) {
  const [selectedTime, setSelectedTime] = useState(dayjs(defaultTime));

  const saveButtonOnClickHandler = () => {
    const convertedTime = convertTimestampToTime(selectedTime);
    dataCallback(convertedTime);
    setIsVisible(false);
  };

  return (
    <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} title={"Edit Start Time"}  >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          label="Start Time"
          value={selectedTime}
          onChange={(newValue) => setSelectedTime(newValue)}
        />
      </LocalizationProvider>
      <OutlineButton
        color={colors.green}
        label={'Save'}
        onClick={saveButtonOnClickHandler}>Save</OutlineButton>
    </ModalContainer>
  );
}

export default TimeSelector;
